import AdminLayout from '../../components/layout/AdminLayout'
import ManagerDashboardBox from '../../components/manager/ManagerDashboardBox'
import styles from '../../styles/admin/Main.module.scss'
import { useLocation } from 'react-router-dom'

const DashboardManager = () => {

  return (
    <AdminLayout>
      <div className={styles.mainContentContainer}>
        <ManagerDashboardBox />
      </div>
    </AdminLayout>
  )
}

export default DashboardManager
